/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFastEndpointsInternalErrorResponseFromDiscriminatorValue, createWebhusetOrderApiFeaturesCartQuoteResponseFromDiscriminatorValue, createWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceededFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartQuoteRequest, serializeWebhusetOrderApiFeaturesCartQuoteResponse, type FastEndpointsInternalErrorResponse, type WebhusetOrderApiFeaturesCartQuoteRequest, type WebhusetOrderApiFeaturesCartQuoteResponse, type WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/quote
 */
export interface QuoteRequestBuilder extends BaseRequestBuilder<QuoteRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartQuoteResponse>}
     * @throws {WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded} error when the service returns a 412 status code
     * @throws {FastEndpointsInternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: WebhusetOrderApiFeaturesCartQuoteRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartQuoteResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartQuoteRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const QuoteRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/quote";
/**
 * Metadata for all the requests in the request builder.
 */
export const QuoteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: QuoteRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            412: createWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceededFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createFastEndpointsInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartQuoteResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartQuoteRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
